import { ApiError } from "./api-client";

const GENERIC_MESSAGE = "Something went wrong. Please try again.";
const RATE_LIMIT_MESSAGE = "Too many requests. Please wait a moment and try again.";
const SERVER_MESSAGE = "Our servers are temporarily unavailable. Please try again later.";

/**
 * Maps API and network errors to safe user-facing copy (no raw HTML/stack traces).
 */
export function getUserFacingError(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 429) return RATE_LIMIT_MESSAGE;
    if (error.status >= 500) return SERVER_MESSAGE;
    if (error.status >= 400) {
      const msg = error.message.trim();
      if (msg && !msg.startsWith("<") && !msg.includes("<!DOCTYPE") && msg.length <= 200) {
        return msg;
      }
      return GENERIC_MESSAGE;
    }
  }

  if (error instanceof Error) {
    const msg = error.message.trim();
    if (!msg) return GENERIC_MESSAGE;
    // Reject messages that look like HTML or server dumps
    if (msg.startsWith("<") || msg.includes("<!DOCTYPE")) return GENERIC_MESSAGE;
    if (msg.length > 200) return GENERIC_MESSAGE;
    return msg;
  }

  return GENERIC_MESSAGE;
}
